import { Box, Button, Grid, TextField } from "@mui/material";
import { useState } from "react";
import { updateBasic, validName, validOptionalAddress, validRequiredAddress } from "./client_halper";
import { validIndianPin } from "../booking/booking_halper";

function BasicEdit({ client, onChange }) {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isLoading) return;
        setIsLoading(true);
        const data = new FormData(event.currentTarget);
        const name = data.get("name");
        const bill_add_1 = data.get("billing_add_1");
        const bill_add_2 = data.get("billing_add_2");
        const bill_add_3 = data.get("billing_add_3");
        const bill_state = data.get("billing_add_state");
        const bill_zip = data.get("billing_add_zip");

        var flag = true;
        if (__error_handler(validName(name), "name", "You have not entered a valid name.")) {
            flag = false;
        }
        if (__error_handler(validRequiredAddress(bill_add_1), "billing_add_1", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(validRequiredAddress(bill_add_2), "billing_add_2", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(validOptionalAddress(bill_add_3), "billing_add_3", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(["Jharkhand", "Bihar", "Orrisa", "West Bangal"].includes(bill_state), "billing_add_state", "Must be an indian state")) {
            flag = false;
        }
        if (__error_handler(validIndianPin(bill_zip), "billing_add_zip", "You have entered an invalid pin code.")) {
            flag = false;
        }

        if (flag) {
            const _json = {
                "name": name, "billing_add_1": bill_add_1, "billing_add_2": bill_add_2, "billing_add_3": bill_add_3,
                "billing_add_state": bill_state, "billing_add_zip": bill_zip, "client": client.client_id
            };
            updateBasic(_json).then((_) => {
                delete _json["auth"];
                onChange({ status: "loaded", message: "change", change: _json });
                setIsLoading(false);
            }).catch((err) => {
                onChange({ status: "loaded", message: "failed", error: err.message });
                setIsLoading(false);
            });
        } else {
            onChange({ status: "loaded", message: "validation_error" });
            setIsLoading(false);
        }
    }

    const validateInputs = (_) => {
        onChange({ status: "loading" });
        return true;
    }
    
    return (
        <Box>
            <Grid container spacing={2} component="form" onSubmit={handleSubmit} noValidate>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <TextField variant="outlined" name="name" fullWidth defaultValue={client.name} error={inputErrors.name} type="text" helperText={inputErrors.name} placeholder="Legal name of company" label="Company Name" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="billing_add_1" defaultValue={client.billing_add_1} fullWidth error={inputErrors.billing_add_1} type="text" helperText={inputErrors.billing_add_1} placeholder="Line 1" label="Billing Address Line 1" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="billing_add_2" defaultValue={client.billing_add_2} fullWidth error={inputErrors.billing_add_2} type="text" helperText={inputErrors.billing_add_2} placeholder="Line 2" label="Billing Address Line 2" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="billing_add_3" defaultValue={client.billing_add_3} fullWidth error={inputErrors.billing_add_3} type="text" helperText={inputErrors.billing_add_3} placeholder="Line 3" label="Billing Address Line 3" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="billing_add_state" defaultValue={client.billing_add_state} fullWidth error={inputErrors.billing_add_state} type="text" helperText={inputErrors.billing_add_state} placeholder="Billing State" label="State" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }}>
                    <TextField variant="outlined" name="billing_add_zip" defaultValue={client.billing_add_zip} fullWidth error={inputErrors.billing_add_zip} type="text" helperText={inputErrors.billing_add_zip} placeholder="Billing Pincode" label="Pincode" />
                </Grid>
                <Grid size={{ xs: 12, sm: 4 }} className="align_text">
                    <Button type="submit" variant="outlined" fullWidth onClick={validateInputs} color="secondary" sx={{ p: { xs: null, sm: 1.7 } }}>Save</Button>
                </Grid>
            </Grid>
        </Box>
    );
}

export default BasicEdit;
